import React, { Component } from 'react';
import { connect } from 'react-redux';
import autobind from 'autobind-decorator';
import { ListGroup, ListGroupItem, Button } from 'reactstrap';
import { ReportSubCategory } from './ReportSubCategory';
@connect(state => ({
	auth: state.apa
}))
export class ReportCategory extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: false,
			isDeleted: false,
		};
	}
	@autobind
	toggleVisibility(event) {
		event.preventDefault();
		this.setState({
			isVisible: !this.state.isVisible
		});
	}
	@autobind
	delete() {
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const id = this.props.report.id;
		const deletedCategory = this.props.category.id;
		const categoryList = this.props.report.categories.map(category => category.id).filter(id => id !== deletedCategory);
		const body = JSON.stringify({
			categories: categoryList
		});
		console.log(body);
		fetch(`/api/reports/${id}/`, { headers, method: 'PATCH', body }).then(res => res.json()).then(() => this.setState({ isDeleted: true }));
	}
	render() {
		const isVisible = this.state.isVisible;
		const isDeleted = this.state.isDeleted;
		const category = this.props.category;
		const report = this.props.report;
		const index = this.props.index;
		if (isDeleted)
			return null;
		const display = isVisible ? 'block' : 'none';
		return (<ListGroupItem key={`report_category_${category.id}`}>
			<a href="" onClick={this.toggleVisibility}>
				{index + 1}. {category.name}
			</a>

			<Button onClick={this.delete} size='sm' color='danger' style={{ float: 'right' }}>
				<i className="fa fa-trash"> </i> Kategorie löschen
			</Button>
				<ListGroup style={{display: display}} className='list-group-root'>
					{category.children.map((child, index) => <ReportSubCategory index={index} report={report} child={child} key={`report_sub_category_${index}`} />)}
				</ListGroup>
		</ListGroupItem>);
	}
}
